import request from '@/utils/http';
import { PFX } from '../../constant/constant.js';

// 查询
export const getSysControlParamList = data => {
    return request({
        url: `${PFX}/backlog/systemControlParams/list`,
        method: 'post',
        data
    });
};

// 新增
export const addControlParams = data => {
    return request({
        url: `${PFX}/backlog/systemControlParams/add`,
        method: 'post',
        data
    });
};

//编辑
export const editControlParams = data => {
    return request({
        url: `${PFX}/backlog/systemControlParams/edit`,
        method: 'post',
        data
    });
};

//删除
export const delControlParams = data => {
    return request({
        url: `${PFX}/backlog/systemControlParams/delete/${data.id}`,
        method: 'get',
    });
};

// 查询某个系统配置参数
export const getSysControlParamByCode = (data) => {
    return request({
        url: `${PFX}/backlog/getSysControlParamByCode`,
        method: 'get',
        params: data
    });
};
